import { defineConfig } from '@chakra-ui/react'
import { deviceSizes } from '@reward-platform/lift/theme/deviceSizes'
import { imageCard } from '~/components/search-and-results/Card/themes/aerLingus'
import { continueButton } from '~/components/search-and-results/ContinueButton/themes/base'
import { button } from '@reward-platform/lift/components/ChakraButton/themes/base'
import { separator } from '@reward-platform/lift/components/Separator/themes/base'
import { label } from '~/components/search-and-results/Label/themes/base'
import { recommendedSection } from '~/components/search-and-results/RecommendedSection/themes/base'
import { showHideButton } from '~/components/search-and-results/ShowHideButton/themes/base'
import { footer } from '~/components/shared/Footer/themes/base'
import { snackbar } from '@reward-platform/lift/components/Snackbar/themes/base'
import { stickyBanner } from '@reward-platform/lift/components/StickyBanner/themes/base'
import { customTabs } from '@reward-platform/lift/components/Tabs/themes/base'
import { paymentOptionsContainer } from '~/components/shared/PaymentOptionsContainer/themes/base'

export const baseTheme = defineConfig({
  globalCss: {
    'html, body, div#__next': {
      lineHeight: 1.4,
    },
    // Chakra sets the body to position: relative, which causes the popover to be positioned incorrectly.
    body: {
      position: 'static !important',
    },
    // In the next Chakra release the popover z-index will be set to 'popover'
    // by default https://github.com/chakra-ui/chakra-ui/commit/f72b2b681182a3810853687201396c7b18163ed3
    '.chakra-popover__popper': {
      zIndex: 'popover !important',
    },
  },

  theme: {
    tokens: {
      breakpoints: {
        xs: {
          value: deviceSizes.xsmall,
        },
        sm: {
          value: deviceSizes.small,
        },
        md: {
          value: deviceSizes.medium,
        },
        lg: {
          value: deviceSizes.large,
        },
        xl: {
          value: deviceSizes.xlarge,
        },
      },
    },

    recipes: {
      // Shared
      button,
      separator,

      // Orders
      paymentOptionsContainer,
    },

    slotRecipes: {
      // Deprecated
      recommendedSection,
      customTabs,

      // Shared
      snackbar,
      stickyBanner,
      footer,

      // Flights
      label,
      continueButton,
      showHideButton,

      // Search & Results
      imageCard,
    },
  },
})
